import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {BreadcrumbMktComponent} from "../breadcrumb-mkt/breadcrumb-mkt.component";
import {NgForOf, NgIf} from "@angular/common";
import {HerosHomeService} from "./services/heros-home.service";
import {environment} from "../../../../environments/environment";
import {NotificationsComponent} from "../../../notifications/notifications.component";
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {capturarFile, closeModal, validateSizeFile} from "../../../utils/utilities";

import { mostrarToast } from "../../../utils/utilities";
import {ServiceNotificationService} from "../../../services/service-notification.service";
import {DomSanitizer} from "@angular/platform-browser";
import {AuthService} from "../../../auth/auth.service";
import {RestService} from "../../../services/rest.services.service";
import {CREATEHOMEHERO, UPDATE_ADD_PROMOTION} from "../../../graphql/graphql.queris";
import {Apollo} from "apollo-angular";

@Component({
  selector: 'app-heros-home',
  standalone: true,
  imports: [
    BreadcrumbMktComponent,
    NgForOf,
    NotificationsComponent,
    ReactiveFormsModule,
    NgIf
  ],
  templateUrl: './heros-home.component.html',
  styleUrl: './heros-home.component.css'
})
export class HerosHomeComponent implements OnInit {

  constructor(
    private herosHomeService: HerosHomeService,
    private fb: FormBuilder,
    private serviceNotifications: ServiceNotificationService,
    private sanitizer: DomSanitizer,
    private authService: AuthService,
    private restService: RestService,
    private apollo: Apollo,





  ) {
  }

  title: string = 'Heros Home';
  route='/dashboardmkt/herosHome';
  dataHerosHome: any[] = [];
  imgUrl = environment.imgUrl;
  formDataForCreateHomeHero: FormGroup = new FormGroup({});
  numeroWhatsapp: string = '593993183975';
  preview: string | ArrayBuffer | null | undefined;
  @ViewChild('inputImage') inputImage!: ElementRef;
  public archivos: any = [];
  isLoading: Boolean = false;
  urlImage: string = '';







  ngOnInit() {

    this.getAllHomeHeros();
    this.inicializeForm()


  }

  cleanId() {

  }

  inicializeForm() {
    this.formDataForCreateHomeHero = this.fb.group({
      nameCampana: ['', Validators.required],
      numeroWhatsapp: ['593993183975', Validators.required],
      linkWhatsapp: ['', Validators.required],
      imagenUrl: [''],
    });
  }

  getAllHomeHeros() {
    this.herosHomeService.getAllHomeheros().subscribe((data: any) => {
      this.dataHerosHome= data.data.allHomeHeros;
    });
  }

  deleteHomeHero(id: string) {
    this.herosHomeService.removeHomeHero(id);
    this.getAllHomeHeros();
  }

  capturarArchivo(event: Event): void {
    const input =  event.target as HTMLInputElement;
    let validate;
    if (input && input.files) {
      validate = validateSizeFile(input.files[0].size);
    }
    if (!validate) {
      mostrarToast('El tamaño de la imagen no puede ser mayor a 5MB', false, this.serviceNotifications);
      this.preview = '';
      this.inputImage.nativeElement.value = '';
      return;
    }
    capturarFile(event, this.sanitizer, this.archivos, (preview) => this.preview = preview);
  }

  sendAllData() {
    if (this.formDataForCreateHomeHero.invalid) {
      mostrarToast('Complete todos los campos', false, this.serviceNotifications);
      return;
    }

    this.isLoading = true;
    this.authService.isTokenExpired();
    const data = new FormData();
    this.archivos.forEach((archivo: any) => {
      data.append('file', archivo);
    });

    if (this.archivos.length === 0) {
      mostrarToast('Seleccione una imagen', false, this.serviceNotifications);
      this.isLoading = false;
      return;
    }else{
      this.restService.post({ url: environment.apiUploadImage, body: data })
        .subscribe((res: any) => {
          this.urlImage = res[0].path;
          this.formDataForCreateHomeHero.patchValue({
            imagenUrl: this.urlImage
          });
          mostrarToast('Imagen subida correctamente', true, this.serviceNotifications);
          // console.log(this.formDataForCreateHomeHero.value);
          this.generateLink();
          // console.log(this.formDataForCreateHomeHero.value);
          this.funcionCreatePromocion(this.formDataForCreateHomeHero.value);
        });
    }
  }

  funcionCreatePromocion( input: any) {

    console.log(input);
    const {nameCampana, linkWhatsapp, imagenUrl} = input;
    const newHeroHome = {
      nameCampana,
      linkWhatsapp,
      imagenUrl
    }


    this.apollo.mutate({
      mutation: CREATEHOMEHERO,
      variables: {
        input: newHeroHome
      },
      context: {
        headers: {
          Authorization: `Bearer ${this.authService.getToken()}`
        }
      }
    }).subscribe((result: any) => {
      this.formDataForCreateHomeHero.reset();
      this.preview = '';
      this.isLoading = false;
      mostrarToast('Promoción importada correctamente', true, this.serviceNotifications);
      this.formDataForCreateHomeHero.patchValue({ numeroWhatsapp: '593993183975' });
      this.inputImage.nativeElement.value = '';
      this.getAllHomeHeros();
      // closeModal(this.importPromocion);
      this.archivos = [];
    }, (error) => {
      mostrarToast('Error al crear la promoción', false, this.serviceNotifications);
    });
  }


  generateLink() {
    const cleanedPhone = this.formDataForCreateHomeHero.value.numeroWhatsapp.replace(/ /g, '');
      const encodedMessage = encodeURIComponent(this.formDataForCreateHomeHero.value.linkWhatsapp);

    this.formDataForCreateHomeHero.patchValue( {linkWhatsapp: `https://wa.me/${cleanedPhone}?text=${encodedMessage}`});
  }
}
